
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class QryMasterGrid extends Serenity.EntityGrid<QryMasterRow, any> {
        // protected getColumnsKey() { return QryMasterColumns.columnsKey; }
        protected getDialogType() { return QryMasterDialog; }
        protected getIdProperty() { return QryMasterRow.idProperty; }
        protected getInsertPermission() { return QryMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return QryMasterRow.localTextPrefix; }
        protected getService() { return QryMasterService.baseUrl; }

        // constructor(container: JQuery) {
        //     super(container);
        // }
    }
}